module.exports = __webpack_public_path__ + "static/Trintech-924b0700ba24f60feffca199101a9dfd.pdf";